(() => {
  const money = (amount) => {
    const cents = Math.round(Number(amount) * 100);
    if (typeof window.formatMoney === "function") {
      return window.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return "$" + Number(amount).toFixed(2);
  };

  const parseJsonScript = (el) => {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "");
    } catch (error) {
      return null;
    }
  };

  const tiersFromRule = (rule) => {
    const rows = (rule && rule.t) || [];
    return rows
      .map((row) => ({
        min: Number(row.m),
        price: Number(row.fp),
      }))
      .filter((row) => row.min > 0 && row.price > 0)
      .sort((a, b) => a.min - b.min);
  };

  const tiersFromCampaigns = (config, productId) => {
    const campaigns = (config && config.campaigns) || [];
    const pid = String(productId || "");
    const match = campaigns.find(
      (campaign) =>
        campaign.status === "active" &&
        Array.isArray(campaign.productIds) &&
        campaign.productIds.map(String).includes(pid)
    );
    if (!match || !Array.isArray(match.tiers)) return [];
    return match.tiers
      .map((tier) => ({
        min: Number(tier.minQty),
        price: Number(tier.fixedPricePerUnit),
        label: tier.buyLabel || "",
      }))
      .filter((row) => row.min > 0 && row.price > 0)
      .sort((a, b) => a.min - b.min);
  };

  const qtyLabel = (tier, next) => {
    if (tier.label) return tier.label;
    if (next) return `Buy ${tier.min}–${next.min - 1}`;
    return `Buy ${tier.min}+`;
  };

  const readTiers = (root) => {
    const rule = parseJsonScript(root.querySelector("[data-offrefy-product-rule]"));
    let tiers = tiersFromRule(rule);
    if (tiers.length) return tiers;
    const config = parseJsonScript(
      document.getElementById(root.getAttribute("data-config-id") || "") ||
        root.querySelector("script[id^='offrefy-json']")
    );
    return tiersFromCampaigns(config, root.getAttribute("data-product-id"));
  };

  const parsePrices = (raw) => {
    try {
      return JSON.parse(raw || "{}");
    } catch (error) {
      return {};
    }
  };

  const fillSave = (template, savings) => {
    return String(template || "You save SAVINGS").replaceAll("SAVINGS", savings);
  };

  const pickTier = (tiers, qty) => {
    let match = null;
    tiers.forEach((tier) => {
      if (qty >= tier.min) match = tier;
    });
    return match;
  };

  const alpineVariantPrice = (productRoot) => {
    if (!productRoot || !window.Alpine || typeof window.Alpine.$data !== "function") return NaN;
    try {
      const data = window.Alpine.$data(productRoot);
      const price = data && data.currentVariant && data.currentVariant.price;
      return Number(price);
    } catch (error) {
      return NaN;
    }
  };

  const ensureWasSave = (priceRoot) => {
    let wasEl = priceRoot.querySelector("[data-showroom-volume-was]");
    let saveEl = priceRoot.querySelector("[data-showroom-volume-price-save]");
    if (!wasEl) {
      wasEl = document.createElement("s");
      wasEl.setAttribute("data-showroom-volume-was", "");
      wasEl.className = "text-scheme-text";
      wasEl.hidden = true;
      const priceEl =
        priceRoot.querySelector("[data-showroom-price]") || priceRoot.querySelector("[data-product-price]");
      if (priceEl) priceEl.insertAdjacentElement("afterend", wasEl);
    }
    if (!saveEl) {
      saveEl = document.createElement("span");
      saveEl.setAttribute("data-showroom-volume-price-save", "");
      saveEl.className = "showroom-volume-price__save";
      saveEl.hidden = true;
      wasEl.insertAdjacentElement("afterend", saveEl);
    }
    return { wasEl, saveEl };
  };

  const detachAlpinePrice = (priceEl) => {
    if (!priceEl || !priceEl.hasAttribute("x-html")) return priceEl;
    const next = priceEl.cloneNode(true);
    next.removeAttribute("x-html");
    priceEl.replaceWith(next);
    return next;
  };

  const bindVolumePrice = (tiers) => {
    const productRoot = document.querySelector("[data-product-root]");
    if (!productRoot) return;

    const qtyInput =
      productRoot.querySelector('input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');
    const priceRoot =
      productRoot.querySelector("[data-showroom-pdp-price]") ||
      (tiers.length ? productRoot.querySelector("[data-product-price]") && productRoot.querySelector("[data-product-price]").parentElement : null);
    if (!qtyInput || !priceRoot) return;

    const hasPack = Boolean(
      priceRoot.hasAttribute("data-showroom-has-pack") ||
        (qtyInput.closest("[data-showroom-has-pack]") && true) ||
        Number(qtyInput.getAttribute("data-pack-min")) > 1 ||
        Number(qtyInput.getAttribute("data-pack-step")) > 1
    );
    if (!tiers.length && !hasPack) return;
    if (priceRoot.dataset.showroomVolumeBound === "true") {
      priceRoot._showroomTiers = tiers.length ? tiers : priceRoot._showroomTiers || [];
      if (typeof priceRoot._showroomUpdatePrice === "function") priceRoot._showroomUpdatePrice();
      return;
    }

    const prices = parsePrices(priceRoot.getAttribute("data-showroom-variant-prices"));
    const formId = qtyInput.getAttribute("form");
    const form = (formId && document.getElementById(formId)) || qtyInput.closest("form");

    const update = () => {
      const qty = Number(qtyInput.value);
      const variantId = form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
      let regularCents = Number(prices[variantId]);
      if (!Number.isFinite(regularCents) || regularCents <= 0) {
        regularCents = alpineVariantPrice(productRoot);
      }
      const activeTiers = priceRoot._showroomTiers || [];
      const tier = Number.isFinite(qty) && qty >= 1 ? pickTier(activeTiers, qty) : null;
      const unitCents = tier ? Math.round(tier.price * 100) : regularCents;
      const shouldManage = hasPack || activeTiers.length > 0;
      if (!shouldManage || !Number.isFinite(qty) || qty < 1 || !Number.isFinite(unitCents) || unitCents <= 0) {
        return;
      }

      let priceEl = priceRoot.querySelector("[data-product-price]");
      if (!priceEl) return;
      if (activeTiers.length || hasPack) {
        priceEl = detachAlpinePrice(priceEl);
      }

      const { wasEl, saveEl } = ensureWasSave(priceRoot);
      const totalCents = unitCents * qty;
      const compareCents = Number.isFinite(regularCents) ? regularCents * qty : 0;
      const saveCents = compareCents > totalCents ? compareCents - totalCents : 0;

      priceEl.textContent = money(totalCents / 100);
      if (saveCents > 0) {
        wasEl.textContent = money(compareCents / 100);
        wasEl.hidden = false;
        saveEl.textContent = fillSave(
          priceRoot.getAttribute("data-save-template") || "You save SAVINGS",
          money(saveCents / 100)
        );
        saveEl.hidden = false;
      } else {
        wasEl.hidden = true;
        wasEl.textContent = "";
        saveEl.hidden = true;
        saveEl.textContent = "";
      }
    };

    priceRoot._showroomTiers = tiers;
    priceRoot._showroomUpdatePrice = update;
    qtyInput.addEventListener("input", update);
    qtyInput.addEventListener("change", update);
    if (form) form.addEventListener("change", update);
    priceRoot.dataset.showroomVolumeBound = "true";
    update();
  };

  const buildTable = (tiers) => {
    const wrap = document.createElement("div");
    wrap.className = "showroom-offrefy-table-wrap product-block mt-5";
    const table = document.createElement("table");
    table.className = "showroom-offrefy-table";
    table.innerHTML = "<thead><tr><th>Quantity</th><th>Price per item</th></tr></thead>";
    const body = document.createElement("tbody");
    tiers.forEach((tier, index) => {
      const next = tiers[index + 1];
      const tr = document.createElement("tr");
      tr.innerHTML = `<td>${qtyLabel(tier, next)}</td><td>${money(tier.price)}</td>`;
      body.appendChild(tr);
    });
    table.appendChild(body);
    wrap.appendChild(table);
    return wrap;
  };

  const reveal = (block) => {
    const root = block && block.querySelector("[data-offrefy-root], .offrefy-root");
    if (!root) return;
    const tiers = readTiers(root);
    bindVolumePrice(tiers);
    if (block.dataset.showroomOffrefyShown === "true") return;
    if (document.querySelector(".showroom-offrefy-table-wrap")) {
      block.dataset.showroomOffrefyShown = "true";
      return;
    }
    const native = root.querySelector("table:not(.showroom-offrefy-table)");
    if (native) {
      const clone = native.cloneNode(true);
      clone.classList.add("showroom-offrefy-table");
      const wrap = document.createElement("div");
      wrap.className = "showroom-offrefy-table-wrap product-block mt-5";
      wrap.appendChild(clone);
      block.insertAdjacentElement("afterend", wrap);
      block.dataset.showroomOffrefyShown = "true";
      return;
    }
    if (!tiers.length) return;
    block.insertAdjacentElement("afterend", buildTable(tiers));
    block.dataset.showroomOffrefyShown = "true";
  };

  const scan = () => {
    document.querySelectorAll(".shopify-block.shopify-app-block").forEach((block) => {
      if (block.querySelector("[data-offrefy-root], .offrefy-root")) reveal(block);
    });
  };

  const tileConfigCache = new Map();

  const parseTileProduct = (tile) => {
    const jsonEl = tile && tile.querySelector("[data-showroom-tile-product]");
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return null;
    }
  };

  const fetchTileTiers = (productId, variantId) => {
    const key = String(productId || "");
    if (!key) return Promise.resolve([]);
    if (tileConfigCache.has(key)) return tileConfigCache.get(key);
    const params = new URLSearchParams({ product_id: key });
    if (variantId) params.set("variant_id", String(variantId));
    const request = fetch("/apps/volume-discount/widget-config?" + params.toString())
      .then((res) => (res.ok ? res.json() : null))
      .then((config) => tiersFromCampaigns(config, key))
      .catch(() => []);
    tileConfigCache.set(key, request);
    return request;
  };

  const updateTilePrice = (tile) => {
    if (!tile) return;
    const qtyInput = tile.querySelector("[data-showroom-qty]");
    const priceEl = tile.querySelector("[data-showroom-price]");
    const priceRoot = tile.querySelector("[data-product-price]") || (priceEl && priceEl.parentElement);
    if (!qtyInput || !priceEl || !priceRoot) return;
    const pack = window.showroomQuantityPack && window.showroomQuantityPack.isPackInput(qtyInput);
    const tiers = tile._showroomTiers || [];
    if (!pack && !tiers.length) return;

    const selectEl = tile.querySelector("[data-showroom-variant]");
    if (selectEl && !selectEl.value) return;

    const qty = Number(qtyInput.value);
    const product = parseTileProduct(tile);
    const variantId =
      (selectEl && selectEl.value) ||
      (tile.querySelector('input[name="id"]') && tile.querySelector('input[name="id"]').value);
    const variant =
      (product &&
        product.variants &&
        product.variants.find((row) => String(row.id) === String(variantId))) ||
      (product && product.variants && product.variants[0]);
    const regularCents = Number(variant && variant.price);
    const tier = Number.isFinite(qty) && qty >= 1 ? pickTier(tiers, qty) : null;
    const unitCents = tier ? Math.round(tier.price * 100) : regularCents;
    if (!Number.isFinite(qty) || qty < 1 || !Number.isFinite(unitCents) || unitCents <= 0) return;

    const { wasEl, saveEl } = ensureWasSave(priceRoot);
    const totalCents = unitCents * qty;
    const compareCents = regularCents * qty;
    const saveCents = compareCents > totalCents ? compareCents - totalCents : 0;
    priceEl.textContent = money(totalCents / 100);
    saveEl.hidden = true;
    saveEl.textContent = "";
    if (saveCents > 0) {
      wasEl.textContent = money(compareCents / 100);
      wasEl.hidden = false;
    } else {
      wasEl.hidden = true;
      wasEl.textContent = "";
    }
  };

  const listenTileQty = (tile, qtyInput) => {
    if (tile.dataset.showroomVolumeListening === "true") return;
    tile.dataset.showroomVolumeListening = "true";
    qtyInput.addEventListener("input", () => updateTilePrice(tile));
    qtyInput.addEventListener("change", () => updateTilePrice(tile));
  };

  const bindTile = (tile) => {
    if (!tile || tile.dataset.showroomVolumeBound === "true") return;
    const qtyInput = tile.querySelector("[data-showroom-qty]");
    const priceEl = tile.querySelector("[data-showroom-price]");
    if (!qtyInput || !priceEl) return;
    tile.dataset.showroomVolumeBound = "true";
    const pack = window.showroomQuantityPack && window.showroomQuantityPack.isPackInput(qtyInput);
    const product = parseTileProduct(tile);
    const productId = product && product.id;
    const variantId =
      (tile.querySelector("[data-showroom-variant]") && tile.querySelector("[data-showroom-variant]").value) ||
      (tile.querySelector('input[name="id"]') && tile.querySelector('input[name="id"]').value);
    if (pack) {
      listenTileQty(tile, qtyInput);
      updateTilePrice(tile);
    }
    fetchTileTiers(productId, variantId).then((tiers) => {
      tile._showroomTiers = tiers;
      if (!pack && !tiers.length) return;
      listenTileQty(tile, qtyInput);
      updateTilePrice(tile);
    });
  };

  const bindTiles = (scope) => {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll("[data-showroom-tile]").forEach(bindTile);
  };

  const start = () => {
    bindVolumePrice([]);
    scan();
    bindTiles(document);
    window.setTimeout(scan, 250);
    window.setTimeout(() => bindTiles(document), 250);
    window.setTimeout(scan, 1000);
    window.setTimeout(() => bindTiles(document), 1000);
  };

  window.showroomOffrefy = {
    updateTile: updateTilePrice,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", (event) => {
    scan();
    bindTiles(event.target);
  });
  document.addEventListener("shapes:section:hasmutated", (event) => {
    bindTiles(event.target);
  });
})();
